import {
  configureStore,
  createAction,
  createReducer,
  getDefaultMiddleware,
  combineReducers,
} from "@reduxjs/toolkit";
import translationSlice from "../common/translation/translationSlice";
import { composeWithDevTools } from "@redux-devtools/extension";
import donationReducer from "../Containers/DonationView/slice";
import dashboardReducer from "../Containers/DashBoardView/slice";
import onBoardingReducer from "../Containers/OnBoarding/slice";
import collectionReducer from "../Containers/CreateCollection/slice";
import adminDashboardReducer from "../Containers/AdminView/adminSlice";
import AuthReducer from "./features/authSlice";
import messageReducer from "../Containers/MessagePanel/slice";
import documentDetailsReducer from "../Containers/DocumentDetails/slice"
import storage from "redux-persist/lib/storage";
import collectorInviteReducer  from "../Containers/CollectorInvitation/slice";
import { persistReducer, persistStore } from "redux-persist";
import thunk from "redux-thunk";
const composedEnhancers = composeWithDevTools();

// const persistConfig = {
//   key: "root",
//   storage,
//   blacklist: ["loading"],
// };
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"],
};



// const persistedAuthReducer = persistReducer(persistConfig, AuthReducer);
// const persistedDonationReducer = persistReducer(persistConfig, donationReducer);
// const persistedDashboardReducer = persistReducer(
//   persistConfig,
//   dashboardReducer
// );
// const persistOnBoardingReducer = persistReducer(
//   persistConfig,
//   onBoardingReducer
// );
// const persistCollectionReducer = persistReducer(
//   persistConfig,
//   collectionReducer
// );
// const persistAdminDashboardReducer = persistReducer(
//   persistConfig,
//   adminDashboardReducer
// );
// const persistMessageReducer = persistReducer(persistConfig, messageReducer);
// const persistDocumentDetailsReducer = persistReducer(persistConfig, documentDetailsReducer);
// const persistCollectorInviteReducer = persistReducer(persistConfig, collectorInviteReducer);

// const combinedReducer = combineReducers({
//   translate: translationSlice,
//   auth: persistedAuthReducer,
//   donationCart: persistedDonationReducer,
//   dashboardInfo: persistedDashboardReducer,
//   onBoarding: persistOnBoardingReducer,
//   collection: persistCollectionReducer,
//   adminDashboard: persistAdminDashboardReducer,
//   messageReducer: persistMessageReducer,
//   documentDetails: persistDocumentDetailsReducer,
//   collectorInvite: persistCollectorInviteReducer
// });
const combinedReducer = combineReducers({
  translate: translationSlice,
  auth: AuthReducer,
  donationCart: donationReducer,
  dashboardInfo: dashboardReducer,
  onBoarding: onBoardingReducer,
  collection: collectionReducer,
  adminDashboard: adminDashboardReducer,
  messageReducer: messageReducer,
  documentDetails: documentDetailsReducer,
  collectorInvite: collectorInviteReducer
});

const persistedReducer = persistReducer(persistConfig, combinedReducer);

const rootReducer = (state, action) => {
  if (action.type === "logout/LOGOUT") {
    action.type = undefined;
    storage.removeItem("persist:root");
    return combinedReducer(undefined, action);
  }
  return combinedReducer(state, action);
};

// export const store = configureStore({
//   reducer: rootReducer,
//   composedEnhancers,
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       serializableCheck: false,
//     }),
// });
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
export default store.getState();
